<template>
  <v-container>
    <v-layout column=true>
      <h1 class="dpr-heading">Arlington County Athletic Field Schedules</h1>
      <v-card><v-card-text>
      <p class="dpr-small">Check here to see if an Arlington field is in use and who has reserved it. There are many ways to sort the data: field name, type of field, who’s reserved it and more. Use the “?” to learn about each sort type.</p>
      <p class="dpr-small">If a field does not appear in a sort, the field was not reserved on that day. Use the export tab at the bottom of each calendar to export calendars into Excel. Reservations canceled due to inclement weather appear in <span class="dpr-weather-cancel">red styling</span> and are labeled as canceled (inclement weather) on the calendar.</p>
      <p class="dpr-small">Calendars are updated twice daily. View the timestamp underneath the list of fields below to see when data was last refreshed.</p>
      <p class="dpr-small">DPR enters schedules in to our reservation system on a cyclical basis. The dates below reflect when calendars are most accurate.
        <ul class="dpr-bullets">
          <li class="dpr-small">Fall Season – Early September</li>
          <li class="dpr-small">Winter Season – Mid-November</li>
          <li class="dpr-small">Spring Season – end-March/early-April</li>
          <li class="dpr-small">Summer Season – Mid-June</li>
        </ul>
      </p>
      <p class="dpr-small">Arlington County’s Department of Parks and Recreation (DPR) allocates fields based on the <a href="https://parks.arlingtonva.us/dpr-sport-user-group/">Athletic Field Allocation Guidelines</a>. DPR activities are scheduled after the needs of Arlington Public Schools are met.</p>
      <p class="dpr-small">If you are interested in renting a field, see <a href="https://parks.arlingtonva.us/rentals/">athletic field rentals on Arlington County Parks</a>.</p>
      </v-card-text></v-card>
      <ParkFilters/>
      <v-layout align-center aria-live="polite" :aria-busy="loading">
        <v-flex grow>
          <v-progress-linear indeterminate :active="loading" class="my-0" aria-hidden="true"/>
        </v-flex>
        <v-flex shrink>
          <v-btn small @click="search" color="primary" :aria-busy="loading">Search</v-btn>
          <v-btn small @click="clear">Clear filters and results</v-btn>
        </v-flex>
      </v-layout>
      <section aria-label="Search results">
        <ParkResults :results="results"/>
      </section>
      <LastUpdatedTimestamp/>
    </v-layout>
  </v-container>
</template>

<script>
  import client from '@/client'
  import LastUpdatedTimestamp from '@/components/LastUpdatedTimestamp'
  import ParkFilters from '@/components/ParkFilters'
  import ParkResults from '@/components/ParkResults'

  export default {
    data: () => ({
      loading: false,
      results: []
    }),
    components: {
      LastUpdatedTimestamp,
      ParkFilters,
      ParkResults
    },
    created: function() {
      document.title = "Arlington County Athletic Field Schedules"
    },
    mounted: function() {
      this.readRoute(this.$route)
    },
    watch: {
      '$route' (to) {
        this.readRoute(to)
      }
    },
    methods: {
      readRoute (to) {
        const pc = to.params.parkCode
        this.$store.commit('setIndex', { filter: 'parkCode', value: pc ? pc : null })
        this.search()
      },
      search () {
        this.loading = true
        client.getFieldsByPark(this.$store.state.index)
          .then(results => {
            this.results = results
          })
          .finally(() => {
            this.loading = false
          })
      },
      clear () {
        this.$router.push('/index')
        this.$store.commit('clearIndex')
        this.search()
      }
    }
  }
</script>

<style>
  .dpr-bullets {
    list-style-type: disc;

  }
  .dpr-weather-cancel {
    color: #c62828;
    font-weight: 600;
  }
</style>
